import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

import {SelectItem} from 'primeng/primeng'

import {AwsService} from "../aws.service";
import {Schema} from "../../api/model/schema";

import {CodemirrorService} from '@nomadreservations/ngx-codemirror';

import 'codemirror/addon/lint/lint.css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/json-lint';

import * as Ajv from 'ajv';
import * as _ from 'lodash';
import { catchError } from 'rxjs/operators';

@Component({
    template: require('./setting-form.component.pug'),
    styles: [require('./setting-form.component.css')]
})
export class SettingFormComponent implements OnInit {
    action: string = 'create';
    siteId: string;

    model: Schema = { schema: '{}', layout: '[]', data: '{}'};
    models: Schema[] = [];

    schemas: SelectItem[] = [];
    schema: string;

    form: any = {};
    formDlg: boolean = false;

    cmConfig: any = {
        lineNumbers: true,
        theme: 'cobalt',
        mode: "application/json",
        gutters: ["CodeMirror-lint-markers"],
        lint: true
    };

    constructor(private route: ActivatedRoute, private _awsService: AwsService, private _codeMirror: CodemirrorService) {
        this.siteId = localStorage.getItem('currentSite');
    }

    async ngOnInit() {
        this.schemas.push({label: 'Nuevo', value: null});
        this.models = (await this._awsService.api.sitesSiteSchemasGet({site: this.siteId})).data.items;
        this.models.forEach(item => this.schemas.push({label: item.name, value: item.name}));

        this._codeMirror.instance$.subscribe((editor) => {});
    }

    onChangeSchema(event: any) {
        if (this.action === 'create') {
            this.schema = _.upperFirst(event.value);
        }
        if (event.originalEvent instanceof MouseEvent) {
            if (!event.value) {
                this.schema = null;
                this.model = { schema: '{}', layout: '[]', data: '{}'};
                this.action = 'create'
            } else {
                this.model = _.find(this.models, {name: event.value});
                this.action = 'update'
            }
        }
    }

    async save() {
        let schema, layout, data;
        try {
            schema = JSON.parse(this.model.schema);
            if (!_.isPlainObject(schema)) {
                console.log('Schema must be a JSON Object!');
                return;
            }
        } catch (err) {
            console.log('Schema must be a JSON Object!', err);
            return;
        }

        try {
            layout = JSON.parse(this.model.layout);
            if (!_.isArray(layout)) {
                console.log('Layout must be a JSON Array!');
                return;
            }
        } catch (err) {
            console.log('Layout must be a JSON Array!', err);
            return;
        }

        try {
            data = JSON.parse(this.model.data);
            if (!_.isPlainObject(data)) {
                console.log('Layout must be a JSON Object!');
                return;
            }
        } catch (err) {
            console.log('Layout must be a JSON Object!', err);
            return;
        }

        const ajv = new Ajv();
        if (!ajv.validateSchema(schema)) {
            console.log('Schema not valid!');
            return;
        }

        try {
            if (this.action === 'create') {
                this.model.name = this.schema;
                this.model = (await this._awsService.api.sitesSiteSchemasPost({site: this.siteId}, this.model)).data;
                this.action = 'update';
            } else if (this.action === 'update') {
                this.model = (await this._awsService.api.sitesSiteSchemasNamePut({site: this.siteId, name: this.model.name}, this.model)).data;
            }
        } catch(err) {
            console.log('Error save schema', err);
            return;            
        }
    }

    preview() {
        let schema, layout, data;
        try {
            schema = JSON.parse(this.model.schema);
            if (!_.isPlainObject(schema)) {
                console.log('Schema must be a JSON Object!');
                return;
            }
        } catch (err) {
            console.log('Schema must be a JSON Object!', err);
            return;
        }

        try {
            layout = JSON.parse(this.model.layout);
            if (!_.isArray(layout)) {
                console.log('Layout must be a JSON Object!');
                return;
            }
        } catch (err) {
            console.log('Layout must be a JSON Object!', err);
            return;
        }

        try {
            data = JSON.parse(this.model.data);
            if (!_.isPlainObject(data)) {
                console.log('Layout must be a JSON Object!');
                return;
            }
        } catch (err) {
            console.log('Layout must be a JSON Object!', err);
            return;
        }

        const ajv = new Ajv();
        if (!ajv.validateSchema(schema)) {
            console.log('Schema not valid!');
            return;
        }

        this.form.schema = schema;
        this.form.layout = layout;
        this.form.data = data;
        this.formDlg = true;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/settings/setting-form.component.ts